<div class="api-overview-skeleton">
  <div class="-left-pane">
    <wp-skeleton height="32px" [width]="'70%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'95%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'85%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="40px" [width]="'120px'" [loading]="true"></wp-skeleton>
  </div>
  <div class="-right-pane">
    <wp-skeleton height="24px" [width]="'80%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'95%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'80%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="40px" [width]="'100px'" [loading]="true"></wp-skeleton>
  </div>
</div>

<div class="api-overview-cards-skeleton row">
  @for (i of [1,2,3]; track i) {
  <div class="col-sm-4">
    <div class="base-card-skeleton">
      <div class="d-flex align-items-center mb-2">
        <wp-skeleton height="32px" [width]="'4px'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="24px" [width]="'60%'" [loading]="true" class="ml-2"></wp-skeleton>
      </div>
      <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="14px" [width]="'95%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="14px" [width]="'80%'" [loading]="true"></wp-skeleton>
    </div>
  </div>
  }
</div>
<div class="api-overview-content-skeleton">
  <wp-skeleton height="28px" [width]="'40%'" [loading]="true"></wp-skeleton>
  <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
  <wp-skeleton height="14px" [width]="'90%'" [loading]="true"></wp-skeleton>
  <wp-skeleton height="14px" [width]="'75%'" [loading]="true"></wp-skeleton>
  <div class="row">
    @for (i of [1,2,3]; track i) {
    <div class="col-sm-4">
      <wp-skeleton height="252px" [width]="'360px'" [loading]="true"></wp-skeleton>
    </div>
    }
  </div>
</div>
